import { useState, useEffect } from "react";

import CustomDropdown from "./CustomDropdown";
import MemeList from "./MemeList";
import BackButton from "./BackButton";

import closeIcon from "./../../images/new/meme/close.svg";
import searchIcon from "./../../images/new/meme/search.svg";
import cameraIcon from "./../../images/new/meme/camera.svg";
import { FileUploader } from "react-drag-drop-files";
import memes from "./Memes";
const MemePopup = ({
  onHide,
  next,
  memeType,
  list,
  selectedTemplate,
  setSelectedTemplate,
  searchType,
  cameraTypeList,
  setEditorPopup
}) => {
  const [popupStep, setPopupStep] = useState("List");
  const [isOtherOption, setIsOtherOption] = useState(false);
  const [cameraType, setCameraType] = useState(null);
  const [cameraError, setCameraError] = useState(false);
  const [imageUrl,setImageUrl] = useState(null)
  const [memeValue, setMemeValue] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [defaultList, setDefaultList] = useState([]);
  const [dataList, setDataList] = useState(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [file, setFile] = useState(null);
  const [validated,setvalidated] = useState(false)
  const [templateData,setTemplateData] = useState([])
  const [defaultMemes,setDefaultMemes] = useState([])
  useEffect(()=>{
    const BASE_URL = "https://hh-devserver-bucket.s3.us-east-2.amazonaws.com/Assets/Images/Meme-Generator-Assets/meme_templates_tagged/"
    setTemplateData([
      ...memes['OPrKtwHSYAA8JYST'].map((meme,index)=>{
        return {
          id:index,
          name:meme,
          image:BASE_URL+meme
        }
      })
    ]
    )
    setDefaultMemes([
      ...memes['OPrKtwHSYAA8JYST'].map((meme,index)=>{
        return {
          id:index,
          name:meme,
          image:BASE_URL+meme
        }
      })
    ]
    )
  },[])
  useEffect(()=>{
    if(!file)
    return 
    validateUpload(file.name)
  },[file])
  useEffect(() => {
    if(!templateData)
      return 
    setMemeValue(memeType[0]);
    setDefaultList(list);
    setDataList(templateData);
    setCameraType(cameraTypeList[0]);
    setSearchValue(searchType[0]);
  }, [templateData]);
  useEffect(()=>{
    if(selectedTemplate)
    setEditorPopup(true)
  },[selectedTemplate])
  useEffect(() => {
    defaultList.forEach((item) => {
      if (item.key === memeValue.key) { 
        setDataList(item);
      }
    });
  }, [memeValue, defaultList]);
  useEffect(()=>{
    if(validated&&imageUrl)
      setSelectedTemplate(imageUrl)
    if(validated&&file)
      {
        const fileObjectURL = URL.createObjectURL(file);
        setSelectedTemplate(fileObjectURL)
      }
  },[validated])
  const handleClose = () => {
    onHide(false);
  };
  function debounce(func, delay) {
    let timerId;
    return function(...args) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
  function partialMatchWord(inputText, partialWord) {
    const regexPattern = new RegExp(`.*${partialWord}.*`, 'gi');
    
    return inputText.match(regexPattern) || [];
  }
    
  
  
  function searchQuery(e) {
    if(e.target.value==""){
      setTemplateData(defaultMemes)
      return 
    }
    const tags = e.target.value.split(' ').filter((val)=>val!='').reduce((previous,current)=>{
      return[...previous,...Object.keys(memes).reduce((prev,curr)=>{
        return [...prev,...partialMatchWord(curr,current)]
        },[])].filter((val)=>val!='') 
    },[])
    const BASE_URL = "https://hh-devserver-bucket.s3.us-east-2.amazonaws.com/Assets/Images/Meme-Generator-Assets/meme_templates_tagged/"
    setTemplateData([...tags.reduce((prev,curr)=>{
      const concat = [...prev,...(memes[curr]||[])]
      return [... new Set(concat)]
    },[]).map((meme,index)=>{
      return {
        id:index,
        name:meme,
        image:BASE_URL+meme
      }
    })])


  }
  const handleSearch = debounce(searchQuery, 300); // 300ms debounce delay

  const handleStep = (value) => {
    setPopupStep(value);
  };

  const handleBack = () => {
    setPopupStep("List");
  };

  const handleSelected = async () => {
    if(!imageUrl)
    return 
    setImageUrl()
    handleClose();
    next(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const droppedFile = e.dataTransfer.files[0];
    setFile(droppedFile);
  };
  const handleFileChange = (e) => {
     setFile(e.target.files[0])
  };
  
  const validateUpload = (url)=>{
    if(url){
    const mimeType = url.split('.')[url.split('.').length-1]
    console.log(mimeType)
    setvalidated(mimeType.toLowerCase() == 'jpg'||mimeType.toLowerCase() == "png")
  }
  }
  return (
    <div className="modalOverlay fade">
      <div className="memeCreatorPopup">
        <div className="memeCreatorHeader">
          <h3 className="modalTitle">
            {popupStep === "List"
              ? "Create"
              : popupStep === "Search"
              ? "Browse Through unsplash for your images"
              : popupStep === "URL" 
              ? "Use a Url address"
              : popupStep === "Camera"
              ? "Use a Camera to take a Picture"
              : "Create"}
          </h3>
          <button onClick={handleClose}>
            <img className="modalCloseIcon" src={closeIcon} alt="Close" />
          </button>
        </div>
        <div className="memeCreatorBody">
          {popupStep === "List" && (
            <>
              <button
                className="customButton primaryButton w-100 otherOptions"
                onClick={() => {
                  setIsOtherOption(!isOtherOption);
                }}
              >
                Other Options
              </button>
              <div className="selectTemplate">
                <div
                  className={`availableTemplates ${
                    isOtherOption ? "hideOnMobile" : ""
                  }`}
                >
                  <div className="filters">
                    <div className="searchWrapper">
                      <input
                        type="text"
                        name=""
                        id=""
                        placeholder="Search for Memes"
                        className="customInput"
                        onChange={handleSearch}
                      />
                      <button className="searchButton">
                        <img src={searchIcon} alt="Search Icon" />
                      </button>
                      {/* <button className="customButton secondaryButton">
                      Random
                    </button>
                    <CustomDropdown
                      options={memeType}
                      extraClass="flexGrow"
                      value={memeValue}
                      setValue={setMemeValue}
                    /> */}
                    </div>
                  </div>
                  {templateData && (
                    <MemeList
                      list={templateData}
                      setSelectedTemplate={setSelectedTemplate}
                    />
                  )}
                </div>
                <div
                  className={`uploadTemplates ${
                    !isOtherOption ? "hideOnMobile" : ""
                  }`}
                >
                  <div  className={`dragUpload ${isDragOver ? 'drag-over' : ''}`}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  >
                    <div className="content">
                      <h4>Drag & Drop</h4>
                      <p>Your Media in this Area</p>
                    </div>
                  </div>
                  <div className="actions">
                    <label
                      htmlFor="image-template"
                      className="customButton rounded primaryButton"
                    >
                      Upload Image
                    </label>
                    {/* <button
                      className="customButton rounded primaryButton"
                      onClick={() => {
                        handleStep("Search");
                      }}
                    >
                      Search
                    </button> */}
                    {/* <button
                      className="customButton rounded primaryButton"
                      onClick={() => {
                        handleStep("Camera");
                      }}
                    >
                      Camera
                    </button> */}
                    <button
                      className="customButton rounded primaryButton"
                      onClick={() => {
                        handleStep("URL");
                      }}
                    >
                      Url Address
                    </button>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    id="image-template"
                    hidden
                    onChange={handleFileChange}
                  />
                </div>
              </div>
            </>
          )}
          {popupStep === "Search" && (
            <>
              <div className="selectTemplate alignCenter ">
                <div className="mobileFirstOrder">
                  <BackButton onClick={handleBack} />
                </div>
                <div className="filters">
                  <div className="searchWrapper flexGrow">
                    <input
                      type="text"
                      name=""
                      id=""
                      placeholder="Search 'Funny', 'Troll', maybe something else?"
                      className="customInput w-100"
                      onChange={()=>{}}
                    />
                  </div>
                  <CustomDropdown
                    options={searchType}
                    value={searchValue}
                    setValue={setSearchValue}
                  />
                </div>
              </div>
              <div className="selectTemplate">
                <div className="availableTemplates">
                  {templateData && (
                    <MemeList
                      list={templateData}
                      setSelectedTemplate={setSelectedTemplate}
                    />
                  )}
                </div>
                <div className="uploadTemplates">
                  <div className="verticalFlex">
                    {selectedTemplate && (
                      <>
                        <div className="selectedImage">
                          <img src={selectedTemplate} alt="" />
                        </div>
                      </>
                    )}
                    {/* <div className="actions">
                      <button
                        className="customButton rounded primaryButton"
                        onClick={handleSelected}
                      >
                        Looks Good
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
            </>
          )}
          {popupStep === "Camera" && (
            <>
              <div className="selectTemplate alignStart">
                <div className="mobileFirstOrder">
                  <BackButton onClick={handleBack} />
                </div>
                <p>
                  Don't be shy! This is what memes are all about. Use your phone
                  or webcam and take a picture of yourself. Make sure you give
                  us access to your device in order to use this feature!
                </p>
              </div>
              <div className="cameraSection">
                {cameraError ? (
                  <>
                    <div className="cameraErrorSection">
                      <h3>We are not able to detect your camera :/</h3>
                      <p>
                        Make sure your camera is connected and not used by any
                        another app, then reload the page!
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="accessedCamera">
                      <div className="chooseCamera mobileFirstOrder">
                        <p>Choose a camera input:</p>
                        <CustomDropdown
                          options={cameraTypeList}
                          value={cameraType}
                          setValue={setCameraType}
                        />
                      </div>
                      <div className="cameraDisplayWrapper">
                        <div className="cameraDisplay"></div>
                        <button className="captureButton">
                          <img src={cameraIcon} alt="" />
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </>
          )}
          {popupStep === "URL" && (
            <>
              <BackButton onClick={handleBack} />
              <div className="urlBar">
                <p>Paste the page URL below:</p>
                <input
                  type="text"
                  placeholder="Image URL goes here"
                  className="customInput w-100"
                  value={imageUrl}
                  onChange={(e)=>{setImageUrl(e.target.value)}}
                />
              </div>
              <div className="text-center">
                <button
                  className="customButton primaryButton"
                  onClick={()=>{
                    validateUpload(imageUrl)
                  }}
                >
                  Ready for Next Step
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemePopup;